import type { LoaderFunctionArgs } from '@remix-run/node';
import invariant from 'tiny-invariant';
import { getPaintColourProduct } from '@modules/project/api';

export const loader = async ({ request, context }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const ids = url.searchParams.getAll('id');
    if (!ids || !ids.length) {
        invariant(ids, 'id is required.');
    }

    return await getPaintColourProduct({
        ...context,
        IDs: ids.map((id) => parseInt(id)),
    });
};

export const QUERY_PAINT_COLOUR_PRODUCT =
    '/remix-api/paint-picker/get-paint-colour-product';
